export default{body:"w_DY",isMonospace:"w_DZ",large:"w_Da",medium:"w_Db",small:"w_Dc",weight400:"w_Dd",weight700:"w_De"};
